export const categoriesList = [
  {
    slug: "influencer-scandal",
    name: "网红塌房",
    description: "跟踪记录每一位网红的至暗时刻",
    articles: [
      {
        id: "cat-article-1",
        title: "某千万粉网红深夜直播翻车，背后金主身份遭实锤曝光",
        excerpt: "据知情人士透露，该网红与多位娱乐圈资本大佬关系密切。",
        imageUrl: "https://readdy.ai/api/search-image?query=Dark%20moody%20streaming%20studio%20scene%20with%20dramatic%20amber%20lighting%2C%20abstract%20silhouette%20at%20desk%2C%20warm%20dark%20tones%2C%20cinematic%20photography%20style&width=800&height=600&seq=cat-inf-01&orientation=landscape",
        views: "128.6万",
        date: "2026-07-06",
      },
      {
        id: "cat-article-2",
        title: "某直播平台头部主播涉嫌数据造假，后台截图被内部员工泄露",
        excerpt: "截图显示该主播直播间真实在线人数不足显示的十分之一。",
        imageUrl: "https://readdy.ai/api/search-image?query=Dark%20computer%20screen%20in%20dimly%20lit%20room%2C%20amber%20glowing%20data%2C%20warm%20dark%20tones%2C%20cinematic%20style&width=800&height=600&seq=cat-inf-02&orientation=landscape",
        views: "176.8万",
        date: "2026-07-04",
      },
      {
        id: "cat-article-3",
        title: "某健身网红被扒真实身材全靠修图，线下偶遇照差距惊人",
        excerpt: "网友偶遇拍到的照片与社交平台发布的精修图判若两人。",
        imageUrl: "https://readdy.ai/api/search-image?query=Dark%20moody%20gym%20interior%20with%20warm%20amber%20lighting%2C%20abstract%20figure%20silhouette%2C%20contrast%20theme%2C%20cinematic%20style&width=800&height=600&seq=cat-inf-03&orientation=landscape",
        views: "95.3万",
        date: "2026-07-03",
      },
    ],
    subCategories: [
      { name: "直播翻车", slug: "live-crash" },
      { name: "数据造假", slug: "data-fraud" },
      { name: "人设崩塌", slug: "persona-collapse" },
      { name: "修图对比", slug: "photoshop-exposed" },
    ],
  },
  {
    slug: "celebrity-scandal",
    name: "明星黑料",
    description: "娱乐圈明星不为人知的另一面",
    articles: [
      {
        id: "cat-article-4",
        title: "某顶流男星夜店私密视频外泄，工作室紧急发声明否认",
        excerpt: "视频中疑似该男星与多名女子亲密互动，画面尺度极大。",
        imageUrl: "https://readdy.ai/api/search-image?query=Moody%20nightclub%20with%20amber%20neon%20lights%2C%20blurred%20figures%2C%20warm%20dark%20tones%2C%20cinematic%20photography&width=800&height=600&seq=cat-cel-01&orientation=landscape",
        views: "256.3万",
        date: "2026-07-06",
      },
      {
        id: "cat-article-5",
        title: "某女团成员私下吸烟喝酒照曝光，清纯人设彻底崩塌",
        excerpt: "照片拍摄于某私人聚会，该成员与多名男性友人举止亲密。",
        imageUrl: "https://readdy.ai/api/search-image?query=Dark%20private%20party%20with%20warm%20candlelight%2C%20abstract%20silhouettes%2C%20burgundy%20tones%2C%20cinematic%20style&width=800&height=600&seq=cat-cel-02&orientation=landscape",
        views: "342.1万",
        date: "2026-07-05",
      },
      {
        id: "cat-article-6",
        title: "知名演员被曝税务问题，多个代言品牌紧急解约切割",
        excerpt: "据税务部门内部消息，该演员涉嫌偷逃税款金额高达数千万元。",
        imageUrl: "https://readdy.ai/api/search-image?query=Dark%20luxury%20office%20interior%20with%20amber%20lighting%2C%20abstract%20documents%20on%20desk%2C%20warm%20tones%2C%20cinematic%20style&width=800&height=600&seq=cat-cel-03&orientation=landscape",
        views: "489.7万",
        date: "2026-07-03",
      },
    ],
    subCategories: [
      { name: "情感纠纷", slug: "relationship-drama" },
      { name: "违法乱纪", slug: "legal-issues" },
      { name: "人设崩塌", slug: "persona-collapse" },
      { name: "黑历史", slug: "dark-history" },
    ],
  },
  {
    slug: "blogger-contrast",
    name: "博主反差",
    description: "揭露博主镜头前后的真实反差",
    articles: [
      {
        id: "cat-article-7",
        title: "知名美食博主被曝人设造假，私底下竟靠代拍年入千万",
        excerpt: "该博主以'真实的日常生活'走红，却被前助理爆出所有内容均有剧本。",
        imageUrl: "https://readdy.ai/api/search-image?query=Dark%20modern%20kitchen%20studio%20with%20warm%20amber%20lighting%2C%20professional%20equipment%2C%20cinematic%20style&width=800&height=600&seq=cat-blg-01&orientation=landscape",
        views: "89.2万",
        date: "2026-07-05",
      },
      {
        id: "cat-article-8",
        title: "某知名夫妻档博主被爆已离婚半年，共同账号实为商业合约",
        excerpt: "据圈内人士透露，二人早在去年底就已办理离婚手续。",
        imageUrl: "https://readdy.ai/api/search-image?query=Dark%20luxurious%20living%20room%20with%20separated%20figures%2C%20warm%20amber%20lighting%2C%20cinematic%20composition&width=800&height=600&seq=cat-blg-02&orientation=landscape",
        views: "203.5万",
        date: "2026-07-04",
      },
      {
        id: "cat-article-9",
        title: "某育儿博主被质疑虐待儿童，警方已介入调查取证",
        excerpt: "多段视频显示该博主在拍摄过程中对儿童有不当行为。",
        imageUrl: "https://readdy.ai/api/search-image?query=Dark%20children%20room%20with%20warm%20amber%20lighting%2C%20tense%20atmosphere%2C%20cinematic%20photography%20style&width=800&height=600&seq=cat-blg-03&orientation=landscape",
        views: "567.3万",
        date: "2026-07-02",
      },
    ],
    subCategories: [
      { name: "假人设", slug: "fake-persona" },
      { name: "家庭纠纷", slug: "family-drama" },
      { name: "商业骗局", slug: "business-scam" },
      { name: "违法曝光", slug: "illegal-exposure" },
    ],
  },
  {
    slug: "exposure-gate",
    name: "网曝门事件",
    description: "全网最劲爆的曝光事件汇总",
    articles: [
      {
        id: "cat-article-10",
        title: "某知名企业高管群聊记录外泄，内部黑暗操作全曝光",
        excerpt: "聊天记录涉及价格垄断、商业贿赂等多重违法内容。",
        imageUrl: "https://readdy.ai/api/search-image?query=Dark%20corporate%20office%20with%20amber%20lighting%2C%20abstract%20phone%20screen%20glowing%2C%20tense%20atmosphere%2C%20cinematic%20style&width=800&height=600&seq=cat-exp-01&orientation=landscape",
        views: "678.2万",
        date: "2026-07-06",
      },
      {
        id: "cat-article-11",
        title: "某综艺节目导演组内部音频流出，剧本安排细节曝光",
        excerpt: "音频清晰记录了导演组如何设计冲突情节和安排选手淘汰顺序。",
        imageUrl: "https://readdy.ai/api/search-image?query=Dark%20TV%20studio%20control%20room%20with%20warm%20amber%20monitors%2C%20cinematic%20atmosphere%2C%20editorial%20style&width=800&height=600&seq=cat-exp-02&orientation=landscape",
        views: "345.6万",
        date: "2026-07-05",
      },
      {
        id: "cat-article-12",
        title: "某电商平台双十一数据造假内幕被前员工实名举报",
        excerpt: "举报材料详细记录了平台如何通过技术手段虚增GMV数据。",
        imageUrl: "https://readdy.ai/api/search-image?query=Dark%20warehouse%20interior%20with%20warm%20amber%20lighting%2C%20packages%2C%20cinematic%20style%2C%20editorial%20photography&width=800&height=600&seq=cat-exp-03&orientation=landscape",
        views: "234.8万",
        date: "2026-07-04",
      },
    ],
    subCategories: [
      { name: "企业黑幕", slug: "corporate-darkness" },
      { name: "内幕交易", slug: "insider-trading" },
      { name: "实名举报", slug: "whistleblower" },
      { name: "数据造假", slug: "data-fraud" },
    ],
  },
];

export const aboutData = {
  brandName: "51吃瓜黑料",
  tagline: "全网最全吃瓜平台",
  description1: "51吃瓜黑料创立于2020年，是国内领先的娱乐资讯聚合平台，专注于为吃瓜群众提供最快、最全、最真实的网红塌房、明星爆料、博主反差等热点内容。",
  description2: "我们的编辑团队遍布全国各地，24小时不间断监控各大社交平台、直播平台、短视频平台的最新动态，确保第一时间将最新鲜的瓜送到您面前。",
  description3: "目前，51吃瓜黑料日均活跃用户已突破百万，累计报道爆料事件超过10万条，是中文互联网最具影响力的吃瓜资讯平台之一。",
  advantages: [
    {
      icon: "ri-timer-flash-line",
      title: "实时更新",
      description: "7x24小时不间断监控，第一时间发布最新爆料，平均更新速度快于同类平台2-3小时",
    },
    {
      icon: "ri-global-line",
      title: "全网聚合",
      description: "覆盖微博、抖音、快手、小红书等各大平台，一站式浏览所有热点爆料，无需切换多个APP",
    },
    {
      icon: "ri-hd-line",
      title: "高清视频",
      description: "提供高清吃瓜视频在线观看，支持多清晰度切换，给您最佳的吃瓜视觉体验",
    },
  ],
  stats: [
    { value: "100万+", label: "日均活跃用户" },
    { value: "10万+", label: "累计爆料事件" },
    { value: "5000+", label: "独家首发内容" },
    { value: "24h", label: "全天候更新" },
  ],
};